import React from 'react';
import './ErrorBoundary.css';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null, 
      errorInfo: null,
      errorId: null 
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { 
      hasError: true,
      errorId: Date.now() // Add unique ID for this error
    };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error details safely
    console.error('ErrorBoundary caught an error:', error);
    console.error('Error info:', errorInfo);
    
    // Safely set state with fallback values
    this.setState({
      error: error || new Error('Unknown error occurred'),
      errorInfo: errorInfo || { componentStack: 'Component stack not available' }
    });
  }

  // Add method to reset error state
  resetError = () => {
    this.setState({
      hasError: false,
      error: null,
      errorInfo: null,
      errorId: null
    });
  }

  render() {
    if (this.state.hasError) {
      // Safely render fallback UI
      return (
        <div className="error-boundary">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="alert alert-danger">
                  <h4>Something went wrong</h4>
                  <p>We're sorry, but something unexpected happened. Please try refreshing the page.</p>
                  <div className="error-actions">
                    <button 
                      className="btn btn-primary"
                      onClick={() => window.location.reload()}
                    >
                      🔄 Refresh Page
                    </button>
                    <button 
                      className="btn btn-secondary"
                      onClick={this.resetError}
                    >
                      🔁 Try Again
                    </button>
                  </div>
                  {process.env.NODE_ENV === 'development' && this.state.error && (
                    <details style={{ whiteSpace: 'pre-wrap', marginTop: '15px' }}>
                      <summary>Error Details (Development Mode)</summary>
                      <div style={{ marginTop: '10px' }}>
                        <strong>Error:</strong>
                        <pre style={{ background: '#f8f9fa', padding: '10px', borderRadius: '4px', fontSize: '12px' }}>
                          {this.state.error.toString()}
                        </pre>
                      </div>
                      {this.state.errorInfo && this.state.errorInfo.componentStack && (
                        <div style={{ marginTop: '10px' }}>
                          <strong>Component Stack:</strong>
                          <pre style={{ background: '#f8f9fa', padding: '10px', borderRadius: '4px', fontSize: '12px' }}>
                            {this.state.errorInfo.componentStack}
                          </pre>
                        </div>
                      )}
                      <div style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
                        <div className="error-id">Error ID: {this.state.errorId}</div>
                      </div>
                    </details>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;